import { rtkapi } from './rtkapi';

const imageapi = rtkapi.enhanceEndpoints({ addTagTypes: ['image', 'part3dfiles', 'part'] }).injectEndpoints({
    endpoints: (build) => ({
        getImages: build.query({
            query: (params) => ({ url: '/images/', params }),
            providesTags: ['image']
        }),
        getImage: build.query({
            query: (id) => ({ url: `/images/${id}/` }),
            providesTags: ['image']
        }),
        createImage: build.mutation({
            query: (body) => ({ url: '/images/', method: 'POST', data: body }),
            invalidatesTags: ['image']
        }),
        updateImage: build.mutation({
            query: ({ id, ...body }) => ({ url: `/images/${id}/`, method: 'PATCH', data: body }),
            invalidatesTags: ['image', "search"]
        }),
        deleteImage: build.mutation({
            query: (id) => ({ url: `/images/${id}/`, method: 'DELETE' }),
            invalidatesTags: ['image']
        }),
        getHotSpots: build.query({
            query: (params) => ({ url: '/hotspots/', params }),
            providesTags: ['image']
        }),

        compareImages: build.mutation({
            query: (body) => ({ url: '/compare-images/', method: 'POST', data: body }),
        }),

        getPart3DFiles: build.query({
            query: (params) => ({ url: '/part3dfiles/', params, responseType: 'blob', }),
            providesTags: ['part3dfiles']
        }),
        getPart: build.query({
            query: (partId) => ({ url: `/parts/${partId}/` }),
            providesTags: ['part']
        }),
        updatePart: build.mutation({
            query: ({ part_number, ...body }) => ({ url: `/parts/${part_number}/`, method: 'PATCH', data: body }),
            invalidatesTags: ['part', 'part3dfiles']
        }),
    })
});

export const { useGetImagesQuery, useGetImageQuery, useCreateImageMutation, useUpdateImageMutation, useDeleteImageMutation, useGetHotSpotsQuery, useCompareImagesMutation, useGetPart3DFilesQuery, useGetPartQuery } = imageapi;